import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";

import { Translate, I18n } from "react-redux-i18n";

import ChargeAnimation from "../utils/components/ChargeAnimation";

import {
  momentModule,
  getPlug,
  roundToDecimals,
  parseAddress,
} from "../utils/Utils";
import { setAlert } from "../../actions/alertActions";
import "../../styles/components/sessions/ChargerSessions.scss";
import no_sessions from "../../styles/images/no_sessions.svg";
import "../../styles/utils/_loadingScreen.scss";
import Select from "react-select";
const { moment, formatDate } = momentModule;


class ChargerSessions extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this._interval = null;
    this.cancel = null;

    this.state = {
      infrastructures: [],
      selectedSession: null,
      infrastructureOptions: [],
      selectedFleet: null,
      selectedCharger: null,
      loading: false,
      hoveredRow: null,
      modals: {
        chargeAnim: false,
      },
    };

    this.fetchChargerSessions = this.fetchChargerSessions.bind(this);
    this.customStyles = this.customStyles.bind(this);
    this.getSessionCellClass = this.getSessionCellClass.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchChargerSessions();
    this._interval = setInterval(this.fetchChargerSessions, 5 * 60 * 1000);
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting");
    if (this._interval !== null) clearInterval(this._interval);
  }

  fetchChargerSessions() {
    this.safeSetState({ loading: true });
    if (this.cancel) this.cancel("New request was made");
    axios
      .get("/api/private/connectionstation/activeSessionsMyChargers", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          const listOfNames = res.data.map((infrastructure) => ({
            value: infrastructure.name,
            label: infrastructure.name,
          }));
          this.safeSetState({
            infrastructures: res.data,
            infrastructureOptions: listOfNames,
          });
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger"),
      ).finally(() => {
        this.safeSetState({
            loading: false,
          });
      })
  }

  stopSession(e, sessionId, hwId, plugId, evId, idTag, chargerType) {
    e.preventDefault();
    this.setModal("chargeAnim", true, () => {
      axios
        .get("/api/private/contracts", {
          cancelToken: new CancelToken((c) => (this.cancel = c)),
        })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.length > 0) {
              const userContracts = res.data.filter(
                (contract) => contract.contractType === "user",
              );
              if (userContracts.length > 0) {
                axios
                  .post(
                    "/api/private/connectionstation",
                    {
                      action: "stop",
                      hwId,
                      chargerType,
                      plugId,
                      sessionId,
                      evId,
                      chargerId: hwId,
                      idTag,
                    },
                    { cancelToken: new CancelToken((c) => (this.cancel = c)) },
                  )
                  .then((res) => {
                    if (res.status === 200) this.fetchChargerSessions();
                  })
                  .catch((err) => {
                    this.setModal("chargeAnim", false);
                    this.props.setAlert(
                      I18n.t(err.response.data.message),
                      "danger",
                    );
                  });
              }
            }
          }
        })
        .catch((err) =>
          this.props.setAlert(I18n.t(err.response.data.message), "danger"),
        );
    });
  }

  setModal(modal, bool, callback) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState(
      {
        modals: newModals,
      },
      callback,
    );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  customStyles() {
    // from react-select docs (https://react-select.com/styles#provided-styles-and-state)
    // The recommended way to provide custom styles to react-select is to use the styles prop. styles takes an object with keys to represent the various inner components that react-select is made up of.

    const customStylesReactSelect = {
      control: (provided) => ({
        ...provided,
        borderRadius: "20px",
        minHeight: "2.7rem",
        height: "2.7rem",
        padding: "0px 5px",
      }),
      valueContainer: (provided) => ({
        ...provided,
        padding: "0px 1rem",
      }),
      input: (provided) => ({
        ...provided,
        margin: "0px",
      }),
      indicatorsContainer: (provided) => ({
        ...provided,
        height: "2.7rem",
      }),
    };
    return customStylesReactSelect;
  }

  getSessionCellClass(session, extra = "") {
    return (
      "col " +
      (this.state.hoveredRow === session._id
        ? "bg-bgdarkgrey"
        : "bg-bglightgrey") +
      (extra ? " " + extra : "")
    );
  }

  render() {
    let filteredInfrastructures = this.state.infrastructures;
    const defaultOption = { value: "", label: I18n.t("history_all") };

    if (this.state.selectedFleet && this.state.selectedFleet.value) {
      filteredInfrastructures = filteredInfrastructures.filter(
        (data) => data.name === this.state.selectedFleet.value,
      );
    }

    const filteredChargers = (filteredInfrastructures || []).flatMap(
      (infrastructure) =>
        (infrastructure.listChargers || []).map((charger) => ({
          value: charger.hwId,
          label: charger.name,
        })),
    );

    const defaultChargerOption = { value: "", label: I18n.t("history_all") };

    let filteredInfrastructuresForTable = filteredInfrastructures;
    if (this.state.selectedCharger && this.state.selectedCharger.value) {
      filteredInfrastructuresForTable = filteredInfrastructures
        .map((infrastructure) => {
          const chargersForInfrastructure = (
            infrastructure.listChargers || []
          ).filter(
            (charger) => charger.hwId === this.state.selectedCharger.value,
          );
          return {
            ...infrastructure,
            listChargers: chargersForInfrastructure,
          };
        })
        .filter(
          (infrastructure) =>
            infrastructure.listChargers &&
            infrastructure.listChargers.length > 0,
        );
    }

    // Custom styles for react-select with menuPortal zIndex
    const selectStylesWithPortal = {
      ...this.customStyles(),
      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    };

    return (
      <>
        <div id="chargerSessions" className="main-container">
          {this.state.infrastructures.length === 0 && !this.state.loading && (
            <div className="no-sessions">
              <img src={no_sessions} alt="" />
              <p className="title">
                <Translate value="sessions_noSessionsTitle" />
              </p>
              <p className="text">
                <Translate value="sessions_noSessionsText2" />
              </p>
            </div>
          )}
          {this.state.infrastructures.length === 0 && this.state.loading && (
            <div className="loading-container flex-jcenter">
              <div className="loading-spinner">
                <div className="generic-loading">
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          )}

          {this.state.infrastructures.length !== 0 && !this.state.loading && (
            <div className="component-container space-between-container">
              <div className="search-select-row flex-row">
                <div className="select-label-container">
                  <p>
                    <Translate value="sessions_place" />
                  </p>
                  <div className="smartSelect">
                    <Select
                      styles={selectStylesWithPortal}
                      value={this.state.selectedFleet || defaultOption}
                      onChange={(e) => {
                        this.setState({
                          selectedFleet: e,
                          selectedCharger: null,
                        });
                      }}
                      defaultValue={defaultOption}
                      options={this.state.infrastructureOptions}
                      isClearable={true}
                      menuPortalTarget={
                        typeof window !== "undefined" ? document.body : null
                      }
                      menuPosition="fixed"
                    />
                  </div>
                </div>
                <div className="select-label-container">
                  {this.state.selectedFleet &&
                    this.state.selectedFleet.value && (
                      <>
                        <p>
                          <Translate value="sessions_charger" />
                        </p>
                        <div className="smartSelect">
                          <Select
                            styles={selectStylesWithPortal}
                            value={
                              this.state.selectedCharger || defaultChargerOption
                            }
                            onChange={(e) => {
                              this.setState({ selectedCharger: e });
                            }}
                            defaultValue={defaultChargerOption}
                            options={filteredChargers}
                            isClearable={true}
                            menuPortalTarget={
                              typeof window !== "undefined"
                                ? document.body
                                : null
                            }
                            menuPosition="fixed"
                          />
                        </div>
                      </>
                    )}
                </div>
              </div>

              <div className="sticky-table-sizing">
                <table
                  className="table-collapse"
                  aria-label={I18n.t("label_myChargers")}
                >
                  <thead>
                    <tr>
                      <th className="bg-evio-secondary-radius-left">
                        <Translate value="sessions_datetime" />
                      </th>
                      <th className="bg-evio-secondary-white">
                        <Translate value="sessions_place" />
                      </th>
                      <th className="bg-evio-secondary-white">
                        <Translate value="sessions_charger" />
                      </th>
                      <th className="bg-evio-secondary-white">
                        <Translate value="sessions_location" />
                      </th>
                      <th className="bg-evio-secondary-white">
                        <Translate value="sessions_user" />
                      </th>
                      <th className="bg-evio-secondary-white">
                        <Translate value="sessions_duration" />
                      </th>
                      <th className="bg-evio-secondary-white">
                        <Translate value="sessions_energySupplied" />
                      </th>
                      <th className="bg-evio-secondary-white">
                        <Translate value="sessions_instantPower" />
                      </th>
                      <th className="bg-evio-secondary-white">
                        <Translate value="sessions_revenue" />
                      </th>
                      <th className="bg-evio-secondary-white">
                        <Translate value="sessions_spent" />
                      </th>
                      <th className="bg-evio-secondary-white">
                        <Translate value="sessions_plug" />
                      </th>
                      <th className="bg-evio-secondary-radius-right">
                        <Translate value="chargers_actions" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredInfrastructuresForTable.map((infrastructure) =>
                      infrastructure.listChargers.map((charger, indexCharger) =>
                        charger.plugs.map((plug, indexPlug) => {
                          const session = plug.session;
                          const m = moment
                            .duration(session.timeCharged, "seconds")
                            .format({ template: "hh:mm", trim: false });
                          return (
                            <tr
                              className="bg-bglightgrey tr-border"
                              key={
                                session._id ||
                                `fallback-${session.evId}-${indexCharger}-${indexPlug}`
                              }
                              onMouseEnter={() => {
                                this.setState({
                                  hoveredRow:
                                    session._id ||
                                    `fallback-${session.evId}-${indexCharger}-${indexPlug}`,
                                });
                              }}
                              onMouseLeave={() => {
                                this.setState({ hoveredRow: null });
                              }}
                            >
                              <td className={this.getSessionCellClass(session)}>
                                {session.startDate ? (
                                  formatDate(session.startDate, "monthtime")
                                ) : (
                                  <p className="blank">―</p>
                                )}
                              </td>
                              <td className={this.getSessionCellClass(session)}>
                                {infrastructure.hasOwnProperty("name") ? (
                                  infrastructure.name
                                ) : (
                                  <p className="blank">―</p>
                                )}
                              </td>
                              <td className={this.getSessionCellClass(session)}>
                                {charger.name ? (
                                  `${charger.name} (${charger.hwId})`
                                ) : (
                                  <p className="blank">―</p>
                                )}
                              </td>
                              <td className={this.getSessionCellClass(session)}>
                                {charger ? (
                                  parseAddress(charger.address)
                                ) : (
                                  <p className="blank">―</p>
                                )}
                              </td>
                              <td className={this.getSessionCellClass(session)}>
                                {session.hasOwnProperty("userName") ? (
                                  session.userName
                                ) : (
                                  <p className="blank">―</p>
                                )}
                              </td>
                              <td className={this.getSessionCellClass(session)}>
                                {m}
                              </td>
                              <td className={this.getSessionCellClass(session)}>
                                {session.totalPower &&
                                !Number.isNaN(session.totalPower) ? (
                                  session.totalPower > 1000 ? (
                                    roundToDecimals(
                                      session.totalPower / 1000,
                                      2,
                                    ) === -1 ? (
                                      <p className="blank">―</p>
                                    ) : (
                                      `${roundToDecimals(
                                        session.totalPower / 1000,
                                        2,
                                      )} kWh`
                                    )
                                  ) : roundToDecimals(session.totalPower, 2) ===
                                    -1 ? (
                                    <p className="blank">―</p>
                                  ) : (
                                    `${roundToDecimals(session.totalPower, 2)} Wh`
                                  )
                                ) : (
                                  <p className="blank">―</p>
                                )}
                              </td>
                              <td className={this.getSessionCellClass(session)}>
                                {session.readingPoints.length !== 0 ? (
                                  session.readingPoints[
                                    session.readingPoints.length - 1
                                  ].instantPower > 1000 ? (
                                    roundToDecimals(
                                      session.readingPoints[
                                        session.readingPoints.length - 1
                                      ].instantPower / 1000,
                                      2,
                                    ) === -1 ? (
                                      <p className="blank">―</p>
                                    ) : (
                                      `${roundToDecimals(
                                        session.readingPoints[
                                          session.readingPoints.length - 1
                                        ].instantPower / 1000,
                                        2,
                                      )} kW`
                                    )
                                  ) : roundToDecimals(
                                      session.readingPoints[
                                        session.readingPoints.length - 1
                                      ].instantPower,
                                      2,
                                    ) === -1 ? (
                                    <p className="blank">―</p>
                                  ) : (
                                    `${roundToDecimals(
                                      session.readingPoints[
                                        session.readingPoints.length - 1
                                      ].instantPower,
                                      2,
                                    )} W`
                                  )
                                ) : (
                                  <p className="blank">―</p>
                                )}
                              </td>
                              <td className={this.getSessionCellClass(session)}>
                                {session.estimatedPrice &&
                                !Number.isNaN(session.estimatedPrice) ? (
                                  roundToDecimals(session.estimatedPrice, 2)
                                ) : (
                                  <p className="blank">―</p>
                                )}
                              </td>
                              <td className={this.getSessionCellClass(session)}>
                                {session.spent !== undefined &&
                                session.spent !== null ? (
                                  session.spent
                                ) : (
                                  <p className="blank">―</p>
                                )}
                              </td>
                              <td className={this.getSessionCellClass(session)}>
                                {plug.connectorType && (
                                  <div className="plug-container">
                                    <img
                                      className="plug-icon plug-image"
                                      src={getPlug(plug.connectorType).plug}
                                      alt=""
                                    />
                                    <div className="plug-info-container">
                                      <p>{getPlug(plug.connectorType).name}</p>
                                      <p>{plug.plugId}</p>
                                      <div className="id-container">
                                        {plug.qrCodeId || "-"}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </td>
                              <td
                                className={
                                  this.getSessionCellClass(session) +
                                  " addShadows"
                                }
                              >
                                <button
                                  type="button"
                                  className="stop-btn"
                                  onClick={(e) =>
                                    this.safeSetState(
                                      { selectedSession: infrastructure },
                                      () =>
                                        this.stopSession(
                                          e,
                                          session.sessionId,
                                          charger.hwId,
                                          plug.plugId,
                                          (session.evId && session.evId._id) ||
                                            "-1",
                                          session.idTag,
                                          charger.chargerType,
                                        ),
                                    )
                                  }
                                >
                                  <Translate value="sessions_stop" />
                                </button>
                              </td>
                            </tr>
                          );
                        }),
                      ),
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          <div className="refresh-info">
            * <Translate value="sessions_refreshInfo" />
          </div>
        </div>

        <ChargeAnimation
          show={this.state.modals.chargeAnim}
          onHide={() => this.setModal("chargeAnim", false)}
          chargerType={
            this.state.selectedSession !== null &&
            this.state.selectedSession.listChargers[0].chargerType
          }
          sessionId={
            this.state.selectedSession !== null &&
            this.state.selectedSession._id
          }
          direction={-1}
        />
      </>
    );
  }
}

export default connect(null, { setAlert })(ChargerSessions);
